export enum ECallCondition {
  Geral = 1,
  Privado = 2,
  Plano = 3
}
